<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  components: {},
};
</script>

<style lang="less" scoped>

#app {
  width: 100%;
  height: 100%;
  user-select: none;
}
.el-cascader-node.in-active-path, .el-cascader-node.is-active, .el-cascader-node.is-selectable.in-checked-path{
  color: #f90 !important;
}
.el-date-table td.today span{
  color: #f90 !important;
}
.el-date-table td.available:hover{
  color: #f90 !important;
}
.el-date-table td.current:not(.disabled) span{
  background-color: #f90 !important;
}
.el-picker-panel__icon-btn:hover{
  color: #f90 !important;
}
.el-date-picker__header-label.active, .el-date-picker__header-label:hover{
  color: #f90 !important;
}
.el-year-table td .cell:hover, .el-year-table td.current:not(.disabled) .cell{
  color: #f90 !important;
}
.el-year-table td.today .cell{
  color: #f90 !important;
}
.el-month-table td.today .cell{
  color: #f90 !important;
}
.el-month-table td .cell:hover{
  color: #f90 !important;
}
.el-checkbox__input.is-checked+.el-checkbox__label{
  color: #f90 !important;
}
.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
  background-color: #f90 !important;
  border-color: #f90 !important;
}
.el-checkbox__inner:hover{
  border-color: #f90 !important;
}

</style>
